import Vue from 'vue';

class FiniteStateMachine {
    constructor(initialState, transitions) {
        this.initialState = initialState;
        this.transitions = transitions;
        this.state = Vue.observable({
            currState: initialState,
            prevState: null,
        });
    }

    transition(event) {
        const transitionMap = this.transitions[this.state.currState];

        if (!transitionMap) {
            console.error(`No transitions defined for current state "${this.state.currState}"`);
            return;
        }

        const nextState = transitionMap?.[event];
        if (nextState) {
            this.state.prevState = this.state.currState;
            this.state.currState = nextState;
        } else {
            console.error(
                `Invalid transition from state "${this.state.currState}" on event "${event}"`
            );
        }
    }

    resetFSM() {
        this.state.currState = this.initialState;
        this.state.prevState = null;
    }

    getAvailableTransitions() {
        return Object.keys(this.transitions[this.state.currState] || {});
    }
}

export default FiniteStateMachine;
